import { useEffect, useState } from 'react';

import { getPlatform } from '../lib/utils';

const INITIAL_STATE = {
  platform: 'unknown',
};

export const usePlatform = () => {
  const [{ platform }, setState] = useState(INITIAL_STATE);
  useEffect(() => {
    setState({ platform: getPlatform() });
  }, []);

  return platform;
};
